import { useEffect } from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import FxCalculator from "@/components/landing/FxCalculator";
import AudienceTabs from "@/components/landing/AudienceTabs";
import ProblemSolution from "@/components/landing/ProblemSolution";
import FeaturesGrid from "@/components/landing/FeaturesGrid";
import CorridorMap from "@/components/landing/CorridorMap";
import HowItWorks from "@/components/landing/HowItWorks";
import SettlementPromise from "@/components/landing/SettlementPromise";
import Compliance from "@/components/landing/Compliance";
import UseCases from "@/components/landing/UseCases";
import DashboardPreview from "@/components/landing/DashboardPreview";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import useReveal from "@/hooks/useReveal";

export default function Landing() {
    useReveal();

    useEffect(() => {
        document.title = "TruoPay";
    }, []);

    return (
        <main data-testid="landing-page" className="bg-white text-zinc-950">
            <Navbar />
            <Hero />
            <FxCalculator />
            <AudienceTabs />
            <ProblemSolution />
            <FeaturesGrid />
            <CorridorMap />
            <HowItWorks />
            <SettlementPromise />
            <Compliance />
            <UseCases />
            <DashboardPreview />
            <FinalCTA />
            <Footer />
        </main>
    );
}
